import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LockService {
  isLocked$: Subject<boolean> = new Subject();
  message$: Subject<string> = new Subject();

  constructor() { }

  lock() {
    this.isLocked$.next(true);
  }

  unlock() {
    this.isLocked$.next(false);
    this.message$.next('');
  }

  message(message:string) {
    this.message$.next(message);
  }
}
